module.exports = __webpack_public_path__ + "img/6.b84e7cdd.png";